module.exports = __webpack_public_path__ + "img/thumb-001-01.ea444170.png";